var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiggyBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_16169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08078 12.7911C0.916781 12.7911 0.800781 10.7879 0.800781 10.3999",
    stroke: "#66676B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5276 12.4089C20.1924 12.1929 19.938 11.8617 19.85 11.4729C19.75 11.0321 19.5988 10.6065 19.4036 10.1985C19.2092 9.7913 19.2068 9.3193 19.3844 8.9049L20.8004 5.6001C19.1204 5.6001 17.8668 6.0233 16.9756 6.5145C16.542 6.7537 16.0204 6.7633 15.5724 6.5529C14.2852 5.9473 12.7924 5.6001 11.2004 5.6001C6.34039 5.6001 2.40039 8.8233 2.40039 12.8001C2.40039 14.3913 3.03879 15.8569 4.10679 17.0481L5.90039 21.2329C6.17799 21.8801 6.78199 22.3681 7.48599 22.3977C8.59879 22.4457 9.46839 21.4737 9.31239 20.3841L9.30439 20.3281C9.26839 20.0753 9.48439 19.8601 9.73799 19.8953C10.2132 19.9625 10.7012 20.0001 11.2004 20.0001C11.6996 20.0001 12.1884 19.9625 12.6636 19.8953C12.926 19.8585 13.13 20.0785 13.094 20.3409C12.986 21.1385 13.39 21.9553 14.1356 22.2593C15.0892 22.6489 16.0892 22.1889 16.458 21.3289L17.4948 18.9105C17.6956 18.4417 18.1084 18.0969 18.6052 17.9817L20.3132 17.5865L21.1964 12.8401L20.5276 12.4089Z",
    fill: "#66676B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4903 15.3025C21.2439 16.6265 20.6599 17.6545 20.1871 17.5985C19.7143 17.5425 19.5311 16.4225 19.7775 15.0985C20.0239 13.7745 20.6079 12.7465 21.0807 12.8025C21.5535 12.8585 21.7367 13.9777 21.4903 15.3025Z",
    fill: "#66676B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 3.9998C12.0176 3.9998 12.8104 4.0886 13.5752 4.2406C13.5808 4.1598 13.5992 4.0822 13.5992 3.9998C13.5992 2.2326 12.1664 0.799805 10.3992 0.799805C8.63202 0.799805 7.19922 2.2326 7.19922 3.9998C7.19922 4.2254 7.22402 4.4446 7.26802 4.6574C8.48242 4.2358 9.80802 3.9998 11.1992 3.9998Z",
    fill: "#66676B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_16169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyBank);
export default __webpack_public_path__ + "static/media/piggyBank.6be9237799860d71b3ce6b48f06397fc.svg";
export { ForwardRef as ReactComponent };